import { render, staticRenderFns } from "./AdditionalServicesModal.vue?vue&type=template&id=e244d75e&scoped=true"
import script from "./AdditionalServicesModal.vue?vue&type=script&lang=ts"
export * from "./AdditionalServicesModal.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalServicesModal.vue?vue&type=style&index=0&id=e244d75e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e244d75e",
  null
  
)

export default component.exports